import React from 'react';
import ParticipantsEditForm from '../ParticipantsEditForm';

class ParticipantNew extends React.Component {

  componentDidMount() {
    this.props.init();
  }

  render() {
    return (
        <ParticipantsEditForm label="Create Participant" {...this.props}/>
    );
  }
}

export default ParticipantNew;


// WEBPACK FOOTER //
// ./src/components/Participants/ParticipantsNew/ParticipantNew.js